const { ORDER_LIST_COLUMN } = require("./actionTypes");

const INIT_STATE = {
  // List Import
  list: {
    items: [],
    totalCount: 0,
    columnsVisible: null,
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-maker_date",
      columnFilter: {},
      keywords: "",
    },
  },
  loadingList: false,
  errorList: null,
};

const orderRunner = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ORDER_LIST_COLUMN:
      const currentColumns = state.list.columnsVisible || {};
      currentColumns[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: { ...state.list, columnsVisible: currentColumns },
      };

    default:
      return state;
  }
};

export default orderRunner;